import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class IeFooter extends Component {
    render() {
        const uid = JSON.parse(sessionStorage.getItem('uid'));
        return (
            <div >
                <a href="http://n.mobioastro.com/ie/tnc-mobioastro?offer=1&device=pc&_next=privacy_policy.html" target="_blank">Privacy Policy</a> | <a href="http://n.mobioastro.com/ie/tnc-mobioastro?offer=1&device=pc&_next=index.html" target="_blank">Terms & Conditions</a> | <a href='' onClick={onUnsubClick} target="_blank">Unsubscribe</a>
            </div>
        );
    }
}

export default IeFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/iefooter.js